import { useModuleBEM } from "@b2bportal/core-themes";
import type { ISummaryLineItem } from "@b2bportal/core-types";
import clsx from "clsx";
import styles from "../styles.module.scss";

export const SummaryLineItem = ({
  label,
  className,
  value,
}: ISummaryLineItem) => {
  const [block, cn] = useModuleBEM(styles, "SummaryItem");

  return (
    <div className={clsx(block, className)}>
      <div className={cn("summary-item-label")}>{label}</div>
      <div className={cn("summary-item-value")}>{value}</div>
    </div>
  );
};
